/**
 * A website address, as a link the browser can actually follow.
 *
 * Client and lead records carry whatever was typed into the website field, and
 * a value with no scheme ("naide.ee") in an `href` is a RELATIVE path - the
 * browser resolves it against the CRM and the link lands on
 * crm.webadmin.ee/naide.ee. The same trap hits every record copied over from
 * the business register, where more than half of the addresses have no scheme
 * (see `lib/webUrl.ts`).
 *
 * The register's own list cell and detail view do not use this component: one
 * needs a shortened label and its own stacking context, the other prints the
 * raw register value. They share the parser, not the markup.
 */
import { webHref } from "../../lib/webUrl";

export function WebsiteLink({ value, className }: { value: string | null | undefined; className?: string }) {
  if (!value) return null;
  const href = webHref(value);
  // Not an address at all (a note, an e-mail). Shown as typed, but not as a
  // link that cannot go anywhere.
  if (!href) return <span className={className}>{value}</span>;
  return (
    <a href={href} target="_blank" rel="noreferrer noopener" className={className ?? "underline"}>
      {value}
    </a>
  );
}
